"use client";

import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";

export const ThemeToggle = () => {
  const { setTheme, resolvedTheme } = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mounted, setMounted] = React.useState(false);
  const isOpen = Boolean(anchorEl);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  const isDark = resolvedTheme === "dark";

  return (
    <>
      <Tooltip title="Tema">
        <IconButton
          aria-label="Alterar tema"
          onClick={(event) => setAnchorEl(event.currentTarget)}
          size="small"
        >
          {mounted && isDark ? <Moon size={18} /> : <Sun size={18} />}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            setTheme("light");
            setAnchorEl(null);
          }}
        >
          Claro
        </MenuItem>
        <MenuItem
          onClick={() => {
            setTheme("dark");
            setAnchorEl(null);
          }}
        >
          Escuro
        </MenuItem>
        <MenuItem
          onClick={() => {
            setTheme("system");
            setAnchorEl(null);
          }}
        >
          Sistema
        </MenuItem>
      </Menu>
    </>
  );
};
